import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from "@ng-select/ng-select";
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';

@Component({
  selector: 'app-assign-date-modal',
  styleUrl: './assign-date.component.scss',
  templateUrl: './assign-date.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatTooltipModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    NgxMaterialTimepickerModule
  ],
})
export class AssignDateModalComponent {
  formData: FormGroup;
  aux_hour: any;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AssignDateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ) { 
    this.formData = this.fb.group({
      datetimeStart: ['', [Validators.required]],
      datetimeEnd: ['', [Validators.required]],
    });
  }

  ngAfterViewInit(): void {
    this.initUpdateForm();
  }

  initUpdateForm(){
    this.formData.setValue({
      datetimeStart: this.data.datetimeStart ? this.data.datetimeStart: null,
      datetimeEnd: this.data.datetimeEnd ? this.data.datetimeEnd : null
    })
  }
  
  save() {
    this.data.datetimeStart = this.formData.value.datetimeStart;
    this.data.datetimeEnd = this.formData.value.datetimeEnd;

    const dataToSend = Object.entries(this.data)
    .reduce((acc, [key, value]) => {
      if (value !== '' && !(Array.isArray(value) && value.length === 0)) { 
        acc[key] = value;
      }
      return acc;
    }, {});
    this.dialogRef.close(dataToSend);
  }
}
